'use es6';

import connectDnd from 'ui-addon-draggable/decorators/connectDnd';
import UIDragList from 'ui-addon-draggable/components/UIDragList';
export default connectDnd(UIDragList);